import { writable } from 'svelte/store';

export type Theme = 'light' | 'dark' | 'system';

const browser = typeof window !== 'undefined';

function getInitialTheme(): Theme {
	if (!browser) return 'system';

	const stored = localStorage.getItem('theme') as Theme;
	if (stored && ['light', 'dark', 'system'].includes(stored)) {
		return stored;
	}
	return 'system';
}

function applyTheme(theme: Theme) {
	if (browser) {
		document.documentElement.setAttribute('data-theme', theme);
	}
}

export const theme = writable<Theme>(getInitialTheme());

if (browser) {
	applyTheme(getInitialTheme());

	theme.subscribe((value) => {
		localStorage.setItem('theme', value);
		applyTheme(value);
	});
}
